// Dashboard.jsx
import React from "react";
import { Container, Row, Col } from "reactstrap";
import SavingChart from "./components/SavingChart";
import CustomerGraph from "./components/CustomerGraph";
import LoanChart from "./components/LoanChart";
import ReportCard from "./components/ReportCard";
import Defaulters from "./components/Defaulters";

const Dashboard = () => {
  return (
    <Container fluid>
      <div className="pt-4">
        <div className="page-content pb-5">
          <div className="d-flex justify-align-start ms-6 ">
            {/* <BreadCrumb  /> */}
            <h5>Dashboard</h5>
          </div>
          <Row>
            <Col lg={5}>
              <ReportCard />
            </Col>
            <Col>
              <Defaulters />
            </Col>
            <Col>
              <CustomerGraph />
            </Col>
          </Row>

          <Row className="align-items-start pb-5">
            <Col lg={6} md={12} sm={12}>
              <SavingChart />
            </Col>
            <Col lg={6} md={12} sm={12}>
              <LoanChart />
            </Col>
          </Row>
        </div>
      </div>
    </Container>
  );
};

export default Dashboard;
